import React from 'react';
import CSVImport from './CSVImport';
import Modal from './Modal';


class CSVImportModal extends React.Component {
    
    constructor(props) {
        super(props);
        this.state = {
            showModal: false,
            showLoading: false
        }
    }
    
    toggleModal = (showModal) =>{
        this.setState({showModal});
    }
    
    onSubmit = (data) => {
        const { onSubmit } = this.props;
        return this.setState({showLoading: true}, ()=>{
            return onSubmit(data).then(()=>{
                this.setState({
                    showModal: false,
                    showLoading: false
                });
            })
            .catch(e=>{
                this.setState({
                    showModal: false,
                    showLoading: false
                });
                return false;
            })
        })
    }
        
    render() {
        const { buttonTitle, buttonClass, modalTitle, onSubmit, fields } = this.props;
        const { showModal, showLoading } = this.state;
        
        return (
            <div>
                <Modal show={showModal} title={modalTitle} showActionButtons={false} dialogClassName="entity-filter-modal" handleClose={()=>this.toggleModal(false)}>
                    <CSVImport fields={fields} onSubmit={this.onSubmit} loading={showLoading} formHeader="Match the column headers from your file to the necessary details below" />
                </Modal>
                <button className={buttonClass} onClick={(e)=>{e.preventDefault(); this.toggleModal(true);}}>{buttonTitle}</button>
                
            </div>
        )
    }
}

export default CSVImportModal